// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Css from "@emotion/css";
import * as Core from "@material-ui/core";
import * as Assets$DvmAdminFrontendFr from "../assets/Assets.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../common/App_Typography.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../intl/messages/Messages_Common.bs.js";

var renaultLogo = Css.css({
      height: "13rem",
      width: "auto"
    });

var appName = Css.css({
      padding: "5rem",
      whiteSpace: "nowrap"
    });

var Styles = {
  renaultLogo: renaultLogo,
  appName: appName
};

function App_Loading_Screen(Props) {
  var message = Props.message;
  var intl = ReactIntl.useIntl();
  return React.createElement(Core.Grid, {
              alignItems: "center",
              children: null,
              container: true,
              direction: "column",
              justifyContent: "center",
              style: {
                minHeight: "100vh"
              }
            }, React.createElement(Assets$DvmAdminFrontendFr.RenaultGroupLogo.make, {
                  className: renaultLogo
                }), React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                  className: appName,
                  children: intl.formatMessage(Messages_Common$DvmAdminFrontendFr.appNameShort),
                  variant: "h1"
                }), React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                  align: "center",
                  children: intl.formatMessage(message),
                  variant: "h5"
                }));
}

var make = App_Loading_Screen;

export {
  Styles ,
  make ,
}
/* renaultLogo Not a pure module */
